var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
let ToggleSwitch = class ToggleSwitch extends LitElement {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.disabled = false;
        this.label = msg('Toggle', { id: 'toggle.default', desc: 'Default toggle label' });
        this.size = 'medium';
        this.variant = 'primary';
    }
    handleChange(e) {
        const input = e.target;
        this.checked = input.checked;
        this.dispatchEvent(new CustomEvent('toggle-change', {
            detail: this.checked,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        const sizeClass = `ggo-toggle--${this.size}`;
        const variantClass = `ggo-toggle--${this.variant}`;
        const disabledClass = this.disabled ? 'ggo-toggle--disabled' : '';
        return html `
      <label class="ggo-toggle ${disabledClass}">
        <input
          type="checkbox"
          role="switch"
          .checked=${this.checked}
          ?disabled=${this.disabled}
          @change=${this.handleChange}
        />

        <span class="ggo-toggle__track ${sizeClass} ${variantClass}">
          <span class="ggo-toggle__thumb"></span>
        </span>

        ${this.label
            ? html `<span class="ggo-toggle__label">${this.label}</span>`
            : null}
      </label>
    `;
    }
};
ToggleSwitch.styles = css `
    :host {
      font-family: inherit;
      display: inline-flex;
      align-items: center;
    }

    .ggo-toggle {
      display: inline-flex;
      align-items: center;
      cursor: pointer;
      gap: 10px;
      user-select: none;
    }

    .ggo-toggle--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    input {
      display: none;
    }

    /* Track */
    .ggo-toggle__track {
      position: relative;
      background: #ccc;
      border-radius: 999px;
      transition: background 0.25s;
      flex-shrink: 0;
    }

    /* Thumb */
    .ggo-toggle__thumb {
      position: absolute;
      top: 2px;
      left: 2px;
      background: #fff;
      border-radius: 50%;
      transition: transform 0.25s;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    /* Checked */
    input:checked + .ggo-toggle__track .ggo-toggle__thumb {
      transform: translateX(100%);
    }

    /* Variants */
    input:checked + .ggo-toggle__track.ggo-toggle--primary {
      background: #0078d4;
    }
    input:checked + .ggo-toggle__track.ggo-toggle--secondary {
      background: #999;
    }
    input:checked + .ggo-toggle__track.ggo-toggle--success {
      background: #28a745;
    }
    input:checked + .ggo-toggle__track.ggo-toggle--danger {
      background: #dc3545;
    }
    input:checked + .ggo-toggle__track.ggo-toggle--warning {
      background: #ffc107;
    }

    /* Sizes */
    .ggo-toggle--small {
      width: 34px;
      height: 18px;
    }
    .ggo-toggle--small .ggo-toggle__thumb {
      width: 14px;
      height: 14px;
    }

    .ggo-toggle--medium {
      width: 42px;
      height: 22px;
    }
    .ggo-toggle--medium .ggo-toggle__thumb {
      width: 18px;
      height: 18px;
    }

    .ggo-toggle--large {
      width: 56px;
      height: 30px;
    }
    .ggo-toggle--large .ggo-toggle__thumb {
      width: 26px;
      height: 26px;
    }

    /* Label */
    .ggo-toggle__label {
      font-size: 14px;
      font-weight: 600;
    }
  `;
__decorate([
    property({ type: Boolean, reflect: true })
], ToggleSwitch.prototype, "checked", void 0);
__decorate([
    property({ type: Boolean })
], ToggleSwitch.prototype, "disabled", void 0);
__decorate([
    property({ type: String })
], ToggleSwitch.prototype, "label", void 0);
__decorate([
    property({ type: String })
], ToggleSwitch.prototype, "size", void 0);
__decorate([
    property({ type: String })
], ToggleSwitch.prototype, "variant", void 0);
ToggleSwitch = __decorate([
    localized(),
    customElement('toggle-switch')
], ToggleSwitch);
export { ToggleSwitch };
//# sourceMappingURL=ToggleSwitch.js.map